import PropTypes from "prop-types";
import SkuBundleImages from "./SkuBundleImages/SkuBundleImages";
import SkuBundleInfo from "./SkuBundleInfo/SkuBundleInfo";
import classes from "./SkuBundleDetails.module.css";

const SkuBundleDetails = (props) => {
  const { details, isDetailsForSku } = props;

  return (
    <section className={classes["sku-bundle-details"]}>
      <SkuBundleImages images={details.images} name={details.name} />
      <SkuBundleInfo
        brandName={details.brandName}
        categoryName={details.categoryName}
        categoryId={details.categoryId}
        subcategoryName={details.subcategoryName}
        subcategoryId={details.subcategoryId}
        id={details.id}
        name={details.name}
        price={details.price}
        isSkuIncludedInBundle={details.isIncludedInBundle}
        isCartRuleApplied={details.isCartRuleApplied}
        availableQuantity={details.availableQuantity}
        images={details.images}
        bundleSkus={details.bundleSkus}
        isInfoForSku={isDetailsForSku}
      />
    </section>
  );
};

export default SkuBundleDetails;

SkuBundleDetails.propTypes = {
  details: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    categoryName: PropTypes.string,
    categoryId: PropTypes.number,
    subcategoryName: PropTypes.string,
    subcategoryId: PropTypes.number,
    brandName: PropTypes.string,
    images: PropTypes.arrayOf(PropTypes.string).isRequired,
    availableQuantity: PropTypes.number,
    price: PropTypes.number.isRequired,
    isIncludedInBundle: PropTypes.bool,
    isCartRuleApplied: PropTypes.bool,
    bundleSkus: PropTypes.arrayOf(
      PropTypes.shape({ id: PropTypes.number, quantity: PropTypes.number })
    ),
  }),
  isDetailsForSku: PropTypes.bool.isRequired,
};
